<div class="cs-notification-popup--wrapper cs-flex-vert">
  @if (data.icon) {
    <div
      class="cs-notification-popup--icon"
      [style.background-color]="iconColor">
      <mat-icon fontSet="cs-icon"
      [fontIcon]="data.icon"></mat-icon>
    </div>
  }
  @if (data.notification) {
    <h2
    [style.color]="notificationColor">{{data.notification}}</h2>
  }
  @for (context of data.additionalContext || []; track context) {
    @if (context) {
      <p
      [innerHTML]="context"></p>
    }
  }
  @if (data.userInput) {
    <div>
      <mat-form-field appearance="outline"
        class="cs-form-field-no-bottom-whitespace">
        <mat-label>Type "Yes" to confirm</mat-label>
        <input matInput
          [(ngModel)]="userInputMessage"
          placeholder="Enter Text"
          name="confirmationMessage"
          autocomplete="off"
          required/>
      </mat-form-field>
    </div>
  }
  @if (data.actionSubText) {
    <p class="mt-1">{{data.actionSubText}}</p>
  }

  @if (data.actions.length) {
    <div class="cs-notification-popup--buttons"
      >
      @for (action of data.actions; track action) {
        <cs-button
          [label]="action.label"
          [buttonStyle]="action.priority"
          [disabled]="isDisabled(action)"
          [overrideStyles]="action.styles"
          (buttonClick)="dialogRef.close(action.action())"/>
      }
    </div>
  }
</div>
